import { InjectableClass } from '@fino/lib-injection';
import _ from 'lodash';

/**
 * This service emulates an Authentication Service.
 */
export class AuthService extends InjectableClass {
  constructor($q, userService, loginService) {
    'ngInject';
    super({ $q, userService, loginService });

    this.cleanup = [];
  }

  /**
   * Returns true if the user is currently authenticated, else false
   */
  isAuthenticated() {
    return this.userService.isSignedIn();
  }

  /**
   * Returns true if the user grants the required role exactly, else false
   */
  grantRole(userRole) {
    return this.userService.hasRole(userRole);
  }

  /**
   * Authenticate user
   */
  authenticate(credentials) {
    return this.loginService.login(credentials);
  }

  injectToken(jwt) {
    this.userService.login(jwt);
  }

  /**
   * Abort authentication
   */
  abortAuthenticate() {
    this.loginService.loginAbort();
  }

  /**
   * Authenticate customer entry
   */
  authenticateCustomerEntry() {
    return this.loginService.customerEntryLogin();
  }

  registerForLogoutCleanup(prFn) {
    this.cleanup.push(prFn);
    return () => {
      const index = this.cleanup.indexOf(prFn);
      this.cleanup.splice(index, 1);
    };
  }

  /**
   * Logs the current user out
   */
  logout() {
    const promises = _.map(this.cleanup, (c) => c());
    return this.$q.all(promises).then(() => {
      this.userService.logout();
    });
  }
}
